import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ee7f6b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "locale-changer" }

import { useI18n } from "vue-i18n"
import { useLocale } from 'vuetify'

export default /*#__PURE__*/_defineComponent({
  __name: 'selectLocale',
  setup(__props) {

const { locale } = useI18n()

const { current } = useLocale()


const changeLocale = (locale_cd: string) => {
  locale.value = locale_cd
  current.value = locale_cd
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      color: "blue-grey-darken-4",
      variant: _ctx.$i18n.locale=='ko' ? 'flat' : 'outlined',
      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeLocale('ko')))
    }, {
      default: _withCtx(() => [
        _createTextVNode("한국어")
      ]),
      _: 1
    }, 8, ["variant"]),
    _createVNode(_component_v_btn, {
      color: "blue-grey-darken-4",
      variant: _ctx.$i18n.locale=='en' ? 'flat' : 'outlined',
      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLocale('en')))
    }, {
      default: _withCtx(() => [
        _createTextVNode("English")
      ]),
      _: 1
    }, 8, ["variant"])
  ]))
}
}

})